import { Selector } from "@ngxs/store";

import { NewsPage } from "../models/news-page";
import { News } from "../models/news.model";
import { NewsState, NewsStateModel } from "./news.state";

export class NewsSelectors {
    @Selector([NewsState])
    public static news(state: NewsStateModel): News[] | undefined {
        return state?.news;
    }

    @Selector([NewsState])
    public static unreadNews(state: NewsStateModel): News[] {
        return state?.unreadNews;
    }

    @Selector([NewsState])
    public static unseenNewsCount(state: NewsStateModel): number {
        return state?.unseenNewsCount || 0;
    }

    @Selector([NewsState])
    public static hasUnseenNews(state: NewsStateModel): boolean {
        return state && state.unseenNewsCount > 0;
    }

    @Selector([NewsState])
    public static currentNews(state: NewsStateModel): NewsPage | undefined {
        return state?.currentNews;
    }

    @Selector([NewsState])
    public static loading(state: NewsStateModel): boolean | undefined {
        return state?.loading;
    }
}
